import { ensureScript } from 'fox-extensions';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

/** For the display on hover behaviour */
export const InfoCardMenuContainer = styled.div`
	/* display: none; */
	opacity: 0;
`;

/** For the display on hover behaviour */
export const InfoCardContainer = styled.div`
	width: 100%;
	padding: 10px;
	border-radius: 10px;
	:focus-within,
	:focus,
	:hover {
		${InfoCardMenuContainer} {
			/* display: initial; */
			opacity: 1;
		}
		background-color: ${props => props.theme.colors.grey[100]};
	}
`;

let loadedStyles = false;

export type BPointSettings = { uat?: boolean };

//use async client script, pass in url instead of this!
export function useBPointClientScripts(settings?: BPointSettings) {
	const baseDomain = settings?.uat ? 'https://bpoint.uat.linkly.com.au' : 'https://www.bpoint.com.au';
	useEffect(() => {
		// <link href="https://www.bpoint.com.au/rest/clientscripts/api.css" rel="stylesheet" />

		if (!loadedStyles) {
			loadedStyles = true;
			const script = document.createElement('link');
			script.href = `${baseDomain}/rest/clientscripts/api.css`;
			script.rel = 'stylesheet';
			document.body.appendChild(script);
		}
	}, [baseDomain]);
	return useEnsureScript(`${baseDomain}/rest/clientscripts/api.js`);
}

export function useEnsureScript(url: string, onLoaded?: () => void): boolean {
	const [loaded, setLoaded] = useState(false);

	useEffect(() => {
		// internally we keep track if this is loaded and only add it once
		ensureScript(url).then(() => {
			setLoaded(true);
			onLoaded?.();
		});
	}, [url]);

	return loaded;
}
